import moment from 'moment'
import React from 'react'

import {
  ADDRESS,
  DATE,
  LINK,
  MULTI_LINE,
  NUMBER,
  SINGLE_LINE,
} from 'ducks/crm/customFields'
import { any } from 'util/arrays'

function formatDate(date) {
  if (!date) return ''
  const asDate = new Date(date)
  const displayYear = asDate.getFullYear() !== new Date().getFullYear()
  return moment(date).format(`D MMM${displayYear ? " 'YY" : ''} @ H:mmA`)
}
export default function CustomFieldValue({
  customFieldType,
  customFieldValue,
}) {
  if (customFieldValue) {
    const {
      city,
      content,
      country,
      link,
      postalCode,
      street,
      street2,
      text,
    } = customFieldValue
    switch (customFieldType) {
      case ADDRESS:
        if (any(x => x && x !== '', Object.values(customFieldValue))) {
          return (
            <div className="address">
              {street && <div className="singleline">{street}</div>}
              {street2 && <div className="singleline">{street2}</div>}
              {city && <div className="singleline">{city}</div>}
              {postalCode && <div className="singleline">{postalCode}</div>}
              {country && <div className="singleline">{country}</div>}
            </div>
          )
        }
        break
      case DATE:
        return formatDate(customFieldValue)
      case LINK:
        if (link) {
          return (
            <a href={link} rel="noopener noreferrer" target="_blank">
              {text || link}
            </a>
          )
        }
        if (text) return text
        break
      case SINGLE_LINE:
      case NUMBER:
        if (content && content !== '') {
          return content
        }
        break
      case MULTI_LINE:
        if (content && content !== '') {
          const lines = content.split(/[\r\n]+/)
          return [].concat(
            ...lines.map((line, i) => [
              line,
              // eslint-disable-next-line react/no-array-index-key
              i + 1 === lines.length ? null : <br key={i} />,
            ])
          )
        }
        break
      default:
      // does nothing
    }
  }
  return <em>Unset</em>
}
